import React, {useEffect, useMemo, useRef} from "react";
import { useIntl } from "react-intl";
import MaterialTable from "@material-table/core";
import { getColumns, OPTIONS, getLocalization } from "./Params";
import { tableIcons } from "../../TableIcons";
import TableStyle from "../../../components/TableStyle";
import {useColumnFilter} from "@feature/commons/hooks/useColumnFilter";

const ProductsTable = ({
  fetch,
  update,
  loading,
  refreshObservable,
}) => {

  // hooks
  const intl = useIntl();
  const {
    fetch: fetchColumnValues,
    isLoading: isColumnSearchLoading,
  } = useColumnFilter();

  // utilities
  const columns = useMemo(
    () => getColumns(intl, fetchColumnValues, isColumnSearchLoading),
    []
  );
  // Check if the product is manually added
  const canRowBeUpdated = ({ manual }) => {
    return manual === true;
  };
  
  // handlers
  const _onRowUpdate = (newData, oldData) =>
    new Promise(async (resolve, reject) => {
      const result = await update(newData, oldData);
      if (!!result) resolve(result)
      else reject();
    });

  // refs
  const tableRef = useRef(null);

  useEffect(() => {
    tableRef.current?.onQueryChange(undefined);
  }, [refreshObservable]);  // eslint-disable-line react-hooks/exhaustive-deps
  
  return (
    <TableStyle>
      <MaterialTable
        tableRef={tableRef}
        data={(query) => fetch(query, columns)}
        columns={columns}
        icons={tableIcons}
        options={OPTIONS}
        localization={getLocalization(intl)}
        isLoading={loading}
        editable={{
          onRowUpdate: _onRowUpdate,
          isEditHidden: (rowData) => !canRowBeUpdated(rowData),
        }}
      />
    </TableStyle>
  );
}

export default ProductsTable;
